import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CaseIdentifiersQueryQuery,
  CaseIdentifiersQueryQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { configurableTypeFragment } from "src/graphql/anti-fraud/fragments/ConfigurableType";
import { useFetchQuery } from "src/graphql/utils";
import { mapDataTypeToAppDataType } from "src/mappers/typedValue.mappers";
import { ClientSchemaIdentifier } from "src/types/clientSchema";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const caseIdentifiersQuery = gql/* GraphQL */ `
  query CaseIdentifiersQuery {
    schema {
      caseTypes {
        ...ConfigurableTypeFragment
      }
    }
  }
  ${configurableTypeFragment}
` as TypedDocumentNode<CaseIdentifiersQueryQuery, CaseIdentifiersQueryQueryVariables>;

export const useGetCaseIdentifiersQuery = ({
  onError,
  caseTypeCode,
}: {
  onError: (error: Error) => void;
  caseTypeCode?: string;
}) => {
  return useFetchQuery(caseIdentifiersQuery, {
    toData: (data) => [
      ...(data?.schema?.caseTypes
        ?.filter((caseType) => !caseTypeCode || caseType.code === caseTypeCode)
        ?.flatMap((caseType) =>
          caseType.elements.flatMap((caseTypeElement) =>
            caseTypeElement.elementType.identifiers.map(
              (identifier) =>
                ({
                  elementCode: caseTypeElement.code,
                  elementName: caseTypeElement.name,
                  identifierCode: identifier.code,
                  identifierTypeCode: identifier.identifierType.code,
                  identifierName: identifier.name,
                  dataType: mapDataTypeToAppDataType(identifier.sourceProperties[0].datatype),
                  clientType: "case",
                } satisfies ClientSchemaIdentifier)
            )
          )
        ) ?? []),
    ],
    isEmpty: (data) => isEmpty(data?.schema?.caseTypes),
    queryOptions: {
      onError,
    },
    uiErrors: {
      fetchError: "FETCH-IDENTIFIER-TYPES-ERROR",
      emptyError: "EMPTY-IDENTIFIER-TYPES-ERROR",
    },
  });
};
